import { MessageEndpointLinkModel } from "../schema/message-endpoint-link.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class MessageEndpointLinkContainer extends MongoBaseContainer{
    message_endpoint_link: MessageEndpointLinkModel
}